import React, { useState, useEffect } from 'react';
import { FaPhone, FaUsers, FaRegCheckCircle , FaFolderOpen, FaArrowUp, FaArrowDown } from 'react-icons/fa';
import Tools from '../utils/Tools';

function AgentsTiles({ allAgentInfo, showTrends }) {
  const [tiles, setTiles] = useState([]);

  useEffect(() => {
    console.log('allAgentInfo has been updated:', allAgentInfo);
    var totalCalls = 0;
    var totalProfessionalism = 0;
    var totalAgents = allAgentInfo.length;
    for (var a = 0; a < allAgentInfo.length; a++) {
      totalCalls += allAgentInfo[a].totalCalls;
      totalProfessionalism += allAgentInfo[a].averageProfessionalism * allAgentInfo[a].totalCalls;
    }
    var averageProfessionalism = (totalProfessionalism / totalCalls).toFixed(3);
    // Update tiles based on allAgentInfo
    setTiles([
      { Icon: FaPhone, title: "Number of Calls", value: Tools.formatNumber(totalCalls || 0) },
      { Icon: FaUsers, title: "Number of Agents", value: Tools.formatNumber(totalAgents || 0) },
      { Icon: FaRegCheckCircle , title: "Average Professionalism", value: Tools.formatNumber(averageProfessionalism || 0) },
      // Add more tiles as needed, using data from allAgentInfo
    ]);
  }, [allAgentInfo]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {tiles.map((tile, index) => (
        <div key={index} className="bg-indigo-700 text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105">
          <div className="flex flex-col items-center flex-grow">
            <div className="flex items-center">
              <p className="text-4xl font-bold">{tile.value}</p>
              {tile.trend && <span className="ml-2">{tile.trend}</span>}
            </div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mt-1">{tile.title}</h3>
          </div>
          <tile.Icon className="text-4xl opacity-70 ml-4" />
        </div>
      ))}
    </div>
  );
}

export default AgentsTiles;